import { Heading, Link, Paragraph } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';
import { Link as RrdLink } from 'react-router-dom';

import { ErrorSupportDetails } from '../../../components/errorSupportDetails';

import { SidebarPageLayout, DetailedAlert } from './styledComponents';

type ErrorStateProps = {
  title?: string | null;
  description?: string | null;
  traceId?: string | null;
};

export const ErrorState = ({ title, description, traceId }: ErrorStateProps) => {
  const { t } = useTranslation();

  return (
    <SidebarPageLayout>
      <DetailedAlert data-color="danger">
        <Heading data-size="xs" level={2}>
          {title || t('generalError.title')}
        </Heading>
        <Paragraph>{description || t('registerScreen.loadRegistrationFailed.description')}</Paragraph>
        <ErrorSupportDetails traceId={traceId} />
        <div>
          <Link asChild>
            <RrdLink to="/">{t('home')}</RrdLink>
          </Link>
        </div>
      </DetailedAlert>
    </SidebarPageLayout>
  );
};
